import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const DressCode = () => {
  const { t } = useLanguage();
  const dressCodeItems = [
    {
      id: 'men',
      icon: 'fas fa-user-tie',
    },
    {
      id: 'women',
      icon: 'fas fa-female-dress',
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const text = {
    women: t('dressCode.women'),
    men:t('dressCode.men')
  }
  
  return (
    <section id="dresscode" className="pt-2 pt-md-5 bg-white">
      <div className="container">
        <motion.div 
          className="text-center mb-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title">{t('dressCode.title')}<div className="title-decoration"><img src="/images/section-title.png" alt="Decorative element" /></div></h2>
          <p className="lead">{t('dressCode.subtitle')}</p>
        </motion.div>
        
        <div className="row justify-content-around">
          {dressCodeItems.map((item, index) => (
            <motion.div 
              key={index}
              className="col-lg-5 col-md-8 col-sm-10 mx-auto mb-3"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="card border-0 shadow h-100">
                <div className="card-body text-center p-4">
                  <div className={`icon-wrapper ${item.id === 'women' ? 'mb-2' : 'mb-3'}`}>
                    <i className={`${item.icon} fa-3x`} style={{ color: 'var(--primary-color)' }}></i>
                  </div>
                  <h4 className="card-title" style={{ color: 'var(--text-dark)' }}>{text[item.id].title}</h4>
                  <p className="card-text text-muted mb-3">{text[item.id].description}</p>
                  
                  <div className="dress-code-details">
                    <ul className="list-unstyled">
                      {text[item.id].details.map((detail, detailIndex) => (
                        <li key={detailIndex} className="mb-2">
                          <i className="fas fa-check-circle text-success me-2"></i>
                          {detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        {/* <motion.div 
          className="text-center mt-2 mt-md-4"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <div className="alert alert-light border-primary" role="alert" style={{ borderColor: 'var(--primary-color)' }}>
            <i className="fas fa-info-circle me-2" style={{ color: 'var(--primary-color)' }}></i>
            <strong>{t('dressCode.note')}</strong>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default DressCode;
